export default {
  "content": "<clipPath id=\"a\"><path d=\"M0 0h16v16H0z\"/></clipPath><clipPath id=\"b\"><path d=\"M0 0h16v16H0z\"/></clipPath><g clip-path=\"url(#a)\"><g clip-path=\"url(#b)\"><path d=\"M2.343 2.343A8.008 8.008 0 00.153 6.44a8.01 8.01 0 003.403 8.212 8.006 8.006 0 008.889 0 8.003 8.003 0 001.211-12.309 7.999 7.999 0 00-11.313 0zM12.243 7c.132-.002.264.022.388.071A.991.991 0 0113.26 8a.991.991 0 01-.299.713 1.004 1.004 0 01-.718.286H9v3.244a.996.996 0 01-.3.695.996.996 0 01-1.4 0 .996.996 0 01-.3-.695V9H3.757a1 1 0 010-2H7V3.757a1.015 1.015 0 01.071-.388A.991.991 0 018 2.74a.991.991 0 01.713.299 1.004 1.004 0 01.286.718V7z\" fill=\"#3f4450\"/></g></g>",
  "attrs": {
    "fill": "none",
    "viewBox": "0 0 16 16",
    "width": "16",
    "height": "16",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};